import html2canvas from "html2canvas";
import { getEnvironmentConfig } from "../../util/saveAPI";

const saveScreenshot = async (imageDataUrl) => {
  const { screenshot_url } = getEnvironmentConfig();
  const options = {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    body: `{"screenshot": "${imageDataUrl}"}`,
  };
  const response = await fetch(screenshot_url, options);
  if (response.status === 200) {
    return response.json();
  }
  console.error("problem uploading screenshot");
  return { Location: "" };
};

const generateScreenshot = (selector) => {
  //const selector = selector || "#front-product-wrapper";
  return new Promise((resolve) => {
    const el = document.querySelector(selector);
    if (!el) resolve(false);
    //size of current bag image
    const size = el.offsetWidth;
    html2canvas(el, {
      allowTaint: true,
      backgroundColor: "#ffffff",
      useCORS: true,
      letterRendering: 1,
      logging: true,
      scrollY: 0,
      scrollX: 0,
      scale: 1,
      //simulate desktop
      windowWidth: 1400,
      windowHeight: 1400,
      width: size,
      height: size,
      onclone: (documentClone) => {
        //set fixed size in dom clone, for generating full size screenshots from mobile
        const container = documentClone.querySelector(selector);
        container.style.width = `${size}px`;
        container.style.height = `${size}px`;
        const monogramTextWrapper = documentClone.querySelector("[data-font-family]");
        if (monogramTextWrapper) {
          const fontFamily = monogramTextWrapper.getAttribute("data-font-family");

          /**
           * For Levi font all characters should be within the same DOM element,
           * so the code pulls the letter from its own <span>s and sets it to the first <span>.
           * The rest of the <span>s are hidden.
           * Also whole DOM tree must have letterSpacing set to 0.
           * If any of the conditions are not met,
           * the Levi uppercase characters will be rendered as lowercase.
           */
          if (fontFamily === "Levi") {
            const domTraverse = (node) => {
              node.style.letterSpacing = "0";
              node.childNodes.forEach((child) => {
                if (child.nodeType === Node.ELEMENT_NODE) {
                  domTraverse(child);
                }
              });
            };
            domTraverse(documentClone.querySelector("html"));
            const text = monogramTextWrapper.textContent?.toLowerCase() || "";
            monogramTextWrapper.childNodes.forEach((child, index) => {
              if (index === 0) {
                child.textContent = text;
              } else {
                child.style.display = "none";
              }
            });
          }
        }
      },
    }).then((canvas) => {
      resolve(canvas);
    });
  });
};

const getFrontCanvas = () => {
  const canvas = generateScreenshot("#monogram-wrapper");
  return canvas;
};

const stitch = async () => {
  const front = await getFrontCanvas();
  return front.toDataURL("image/jpeg", 0.75);
};

export const generateAndUploadScreenshot = async () => {
  const image = await stitch();
  const res = await saveScreenshot(image);
  return res.Location;
};
